import styled from 'styled-components'
import { rem } from 'polished'
import Switch from 'LuxKit/Switch/Switch'
import { setSvgIconSize } from 'LuxKit/SvgIcon'

const SWITCH_KNOB = 16
const SWITCH_PADDING = 2

export const SmallSwitch = styled(Switch)`
  height: ${rem(SWITCH_KNOB + SWITCH_PADDING * 2)};
  width: ${rem(SWITCH_KNOB * 2)};

  > div {
    width: ${rem(SWITCH_KNOB)};
    height: ${rem(SWITCH_KNOB)};
    > svg { ${setSvgIconSize(SWITCH_KNOB)} }
  }

  &:has(:checked) > div {
    transform: translateX(${rem(SWITCH_KNOB - SWITCH_PADDING * 2)});
  }
`

export const InfoIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${props => props.theme.palette.neutral.default.three};
`
